import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';

/** "Bu sahifada": sarlavha bloklaridan; o'qilayotgan bo'lim ajratib ko'rsatiladi. */
export function ArticleToc({ headings }: { headings: Array<{ id: string; text: string }> }) {
  const { t } = useTranslation();
  const [active, setActive] = useState<string | null>(null);
  const ids = headings.map((h) => h.id).join('|');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.find((entry) => entry.isIntersecting);
        if (visible) setActive(visible.target.id);
      },
      { rootMargin: '-80px 0px -70% 0px' },
    );
    ids.split('|').forEach((id) => {
      const el = id ? document.getElementById(id) : null;
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [ids]);

  return (
    <nav aria-label={t('learn.onThisPage')}>
      <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-content-muted">{t('learn.onThisPage')}</h2>
      <ul className="space-y-2 border-l border-line text-sm">
        {headings.map((h) => (
          <li key={h.id}>
            <a
              href={`#${h.id}`}
              aria-current={active === h.id ? 'location' : undefined}
              className={cn(
                '-ml-px block border-l-2 pl-3 transition-colors',
                active === h.id
                  ? 'border-brand-500 font-medium text-brand-600'
                  : 'border-transparent text-content-secondary hover:text-content',
              )}
            >
              {h.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
